import { useState } from 'react';
import { getHookEventElement } from '../utils/internal/getHookEventElement';
import { useOnElementResize } from './useOnElementResize';
/** Get client sizes of some element */
export function useClientSize(ref) {
    var _a = useState(0), clientWidth = _a[0], setClientWidth = _a[1];
    var _b = useState(0), clientHeight = _b[0], setClientHeight = _b[1];
    useOnElementResize(ref, function () {
        var element = getHookEventElement(ref);
        if (!element) {
            return;
        }
        setClientWidth(element.clientWidth);
        setClientHeight(element.clientHeight);
    });
    return { clientWidth: clientWidth, clientHeight: clientHeight };
}
//# sourceMappingURL=useClientSize.js.map